<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon"  [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faUser"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.personaMapper' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 cursorArrow">
        <p class="titleParagraph">{{'personaMapper.toolHeaderLine1' | translate}}<br>
          {{'personaMapper.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span class="cursorPointer">
                <a type="button" (click)="openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span class="cursorPointer">
                <a id="personaYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkPM">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span class="cursorPointer" (click)="goToView();generateReport()">
                <fa-icon class="fas fa-lg" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td rowspan="2">
              <span class="cursorPointer">
                <fa-icon class="fas fa-lg" [icon]="faArrowAltCircleLeft"
                  (click)="mainComponent.openTool('personaMapperMindMap')" routerLink="/main/personaMapperMindMap">
                </fa-icon>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="persona-mapper tool-body-height">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="persona-mapper-table-height">
        <div class="row full-width only-bottom-padding card p-1 bg-white h-50">
          <div class="h-100">
            <!-- <div class=" row strict p-2 interactionGraphHeader overflowYTextHidden">
              <div class="col col-11 col-xs-10 col-sm-11 col-md-11 col-lg-11">
                <h6>
                  <span class="selectedHeaderNameClassInteraction"></span>
                  <span class="selectedHeaderCountInteraction"></span>
                </h6>
              </div>
              <div class="col col-1 col-xs-2 col-sm-1 col-md-1 col-lg-1">
                <div class="row strict">
                  <h6 class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

                  </h6>
                </div>
              </div>
            </div> -->
            <div class="interactionGraphArea interaction-graph-part-height">

              <span id="interactionMapper"></span>
              <!-- <p [innerHTML]="interactionMapper" ></p> -->
              <!-- [innerHTML]="html | safeHtml" -->
            </div>
          </div>
        </div>
        <div class="card p-1 mb-2 bg-white h-50 menuItemsClrWhite">
          <div class="row strict">
            <div class="col-md-12">
              <ul class="nav nav-tabs " role="tablist">
                <li class="dropdown" id="yAxisActiveTabPM" [ngClass]="{ 'active':mapAciveAxisType==='yAxis'}"
                  (click)="changeAxisTab('yAxis');setSelectedYEut('Requirement')">
                  <!-- From value is Persona -->
                  <a ng-attr-data-target="#xeutp1" role="tab" data-toggle="tab"
                    class="xSelectPersona xSelectPersonaclick" id="yAxisPersonaPM">
                    (From)-{{ 'entities.Ur' | translate }}&nbsp;
                    ({{(modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount)}})
                  </a>
                </li>

                <li class="dropdown" id="xAxisActiveTabPM" [ngClass]="{ 'active':mapAciveAxisType==='xAxis'}"
                  (click)="changeAxisTab('xAxis');setSelectedXEut('persona')">
                  <!-- To value is Requirements -->
                  <a ng-attr-data-target="#yeutp1" role="tab" data-toggle="tab" class="ySelectEut"
                    id="xAxisRequirementPM">
                    (To)-{{ 'landscape.personaHeader' | translate }}&nbsp;({{modelData.persona.length}})
                  </a>

                </li>
              </ul>
            </div>
          </div>
          <!-- Tab panes -->
          <div class="tab-content mb-0 interaction-nav-tab-table-height">

            <div class="tab-pane h-100 overflowYTextAuto" ng-attr-id="xeut1M"
              [ngClass]="{ 'active':mapAciveAxisType==='xAxis'}">
              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack">
                <thead class="w-100">
                  <tr class=" row strict border-bottom1px">
                    <th class="col-xs-1">
                      <div style="text-align: center;">
                      </div>
                    </th>
                    <th class="col-xs-1"></th>
                    <th class="col-xs-9 cursorArrow">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody id="list-of-yeut" class="toolEntityTBody">
                  <tr class="row strict border-bottom1px" *ngFor="let per of modelData.persona; let tabIndex = index">

                    <td class="col-xs-1">
                      <div style="text-align: center;">
                        <input type="checkbox" class="cursorPointer" [checked]="isCheckedPersona(per.pType)"
                          [ngClass]="{dis:mainComponent.IMcheckboxReadOnly== true}"
                          (click)="mapEntity($event,per.pType,selectedEUT.eID);getMappingInteraction();loadInteractionMapper();">
                      </div>
                    </td>
                    <td class="col-xs-1 cursorArrow">
                      {{tabIndex+1}}
                    </td>
                    <td class="col-xs-9 cursorArrow">
                      {{per.pName}}
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div class="tab-pane active  h-100 overflowYTextAuto" ng-attr-id="yeut1M"
              [ngClass]="{ 'active':mapAciveAxisType==='yAxis'}">
              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack" *ngIf="entityExists(model.xeutType)">
                <thead class="w-100" *ngIf="entityExists(model.xeutType)">
                  <tr class="row strict border-bottom1px">
                    <th class="col-xs-1 ">
                    </th>
                    <th class="col-xs-4">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownMapperBtn"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button ">
                              Modules
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black w-100">
                          <li class="row padding-vertical" *ngFor="let m of modelData.modules">
                            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly cursorPointer"
                                  (click)="addToModuleFilter(m,$event.target.checked)" type="checkbox">
                              </div>
                            </div>
                            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 dropdown-item cursorArrow">
                              {{m.mName}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th class="col-xs-6">
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                          [placeholder]="'entities.searchEntity' | translate ">
                        <span class="input-group-addon " id="basic-addon2">
                          <fa-icon class="fas icon-black" [icon]="faSearch"></fa-icon>
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody id="list-of-xeut" class="toolEntityTBody">
                  <tr class=" row strict border-bottom1px"
                    *ngFor="let eut of modelData.listOfEUTs|entityMapperFilter:mapperFilterEtype:moduleSelected:searchText:triggerPipe">

                    <td class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input type="radio" name="perosonaRadio" class="checkboxReadOnly radio-groups cursorPointer"
                          [checked]="selectedEUT.eID == eut.eID" (click)="getMappingInteractionSelected(eut)">
                      </div>
                    </td>

                    <td class="col-xs-10 cursorArrow">{{getModuleName(eut)}} | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="model.xTabValid" class="row entity-row">
        <div style="text-align: center;">
          <div class="btn-group" role="group">
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }" (click)="firstPage();setPage(1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepBackward"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }"
              (click)="previousPage();setPage(pager.currentPage - 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleLeft"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="nextPage();setPage(pager.currentPage + 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleRight"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="lastPage();setPage(pager.totalPages)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepForward"></fa-icon>
            </button>
          </div>

        </div>
      </div>
      <div *ngIf="!model.xTabValid" class="row entity-row">
        <div style="text-align: center;">
          <div class="btn-group" role="group">
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }" (click)="firstPage();setPage(1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepBackward"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }"
              (click)="previousPage();setPage(pager.currentPage - 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleLeft"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="nextPage();setPage(pager.currentPage + 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleRight"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="lastPage();setPage(pager.totalPages)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepForward"></fa-icon>
            </button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="personamapperMindmapTip" class="carousel slide" data-ride="carousel" data-interval="false"
        data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'personaMapper.tip1' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'personaMapper.tip2' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'personaMapper.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#personamapperMindmapTip"
          data-slide="prev">
          <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#personamapperMindmapTip"
          data-slide="next">
          <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkPM" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkPM" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.personamapper' | translate}}</h4>
          </div>
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="PmVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>